export const sanitizeValue = (value: string) =>
    value.replace(/[^\d.,-]+/g, '');
